import createPalette from './createPalette';

const createTheme = (theme) => {
  const newTheme = {};

  Object.keys(theme).forEach((colorName => {
    const hexColor = theme[colorName];

    if (!hexColor) {
      return console.warn(
        `No color supplied for theme property \`${colorName}\``
      );
    }

    if (typeof hexColor === 'object') {
      newTheme[colorName] = hexColor;
    } else if (typeof hexColor === 'string') {
      newTheme[colorName] = createPalette(hexColor);
    }
  }));

  return newTheme;
};

export default createTheme;



// WEBPACK FOOTER //
// ./src/styles/createTheme.js